var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankProductAndServicePfm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3116.000000, -899.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-Product-and-Service/PFM",
    transform: "translate(3116.000000, 899.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.818,0 C17.806,0 17.792,0.001 17.779,0.001 L17.779,14.144 L32,14.144 C31.979,6.33 25.637,0 17.818,0 L17.818,0 Z M28.365,17.78 C28.365,17.793 28.366,17.804 28.366,17.817 C28.366,25.651 22.016,32 14.183,32 C6.349,32 0,25.651 0,17.817 C0,9.998 6.328,3.658 14.144,3.636 L14.144,17.78 L28.365,17.78 Z",
    id: 142
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankProductAndServicePfm);
export default __webpack_public_path__ + "static/media/bank-product-and-service-pfm.0cb652a1.svg";
export { ForwardRef as ReactComponent };